import { Component, h, ComponentInterface, Host, Prop } from "@stencil/core";

export type IconButtonVariant = "dark" | "light";

@Component({
    tag: "uic-icon-button",
    styleUrl: "icon-button.scss",
})
export class IconButton implements ComponentInterface {
    /**
     * If set to `true`, the user cannot interact with the button.
     */
    @Prop({ reflect: true }) disabled = false;

    /**
     * If set to `true`, the button is considered selected or toggled.
     */
    @Prop({ reflect: true }) selected = false;

    /**
     * Button variant. Use the "light" variant on dark backgrounds
     */
    @Prop() variant: IconButtonVariant = "dark";

    /**
     * The name of the icon to show.
     */
    @Prop() icon: string;

    render() {
        return (
            <Host class={`uic-icon-button--${this.variant}`}>
                <button
                    class="uic-icon-button__button"
                    disabled={this.disabled}
                >
                    <uic-icon name={this.icon}></uic-icon>
                </button>
            </Host>
        );
    }
}
